// components/shared/RequestDetailActionButton.jsx

import React from "react";
import { Box, Button, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

/**
 * 詳細画面用アクションボタン（用途ごとに文言・遷移先も指定可能）
 *
 * @param {string} viewerType - "user" または "company"
 * @param {boolean} hasRequest - 募集要項が存在するか
 * @param {boolean} isActive - 受付中か
 * @param {string} [buttonLabel] - ボタンの文言
 * @param {string} [buttonUrl] - クリック時の遷移先URL（ユーザー用）
 * @param {string} [tooltip] - 無効時に表示するツールチップ文言（ユーザー用）
 * @param {string} [companyButtonLabel] - 企業側のボタン文言
 * @param {string} [companyButtonUrl] - 企業側の遷移先
 */
const RequestDetailActionButton = ({
  viewerType,
  hasRequest = false,
  isActive = false,
  buttonLabel,
  buttonUrl,
  tooltip,
}) => {
  // 企業側ボタン（文言も遷移先もpropsで指定可）
  if (viewerType === "company") {
    const navigate = useNavigate();
    return (
      <Box display="flex" justifyContent="center">
        <Button
          variant="contained"
          color="inherit"
          onClick={() => navigate("/company/candidates")}
          sx={{
            backgroundColor: "#ffffff",
            color: "#000",
            borderRadius: 9999,
            px: 4,
            fontWeight: "bold",
            border: "1px solid #9ca3af",
            "&:hover": { opacity: 0.9 },
            textAlign: "center",
          }}
        >
          人材一覧画面に戻る →
        </Button>
      </Box>
    );
  }

  // ユーザー側ボタン（文言や遷移先・ツールチップをpropsで指定可）
  return (
    <Box display="flex" justifyContent="center">
      <Tooltip title={!hasRequest || !isActive ? tooltip : ""}>
        <span>
          <Button
            variant="contained"
            color="inherit"
            disabled={!hasRequest || !isActive}
            onClick={() => (window.location.href = buttonUrl)}
            sx={{
              backgroundColor: "#ffffff",
              color: "#000",
              borderRadius: 9999,
              px: 4,
              fontWeight: "bold",
              border: "1px solid #9ca3af",
              "&:hover": { opacity: 0.9 },
              "&.Mui-disabled": {
                backgroundColor: "#f3f4f6",
                color: "#aaa",
                borderColor: "#ccc",
              },
              textAlign: "center",
            }}
          >
            {/* ユーザー側ボタン */}
            {buttonLabel}
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

export default RequestDetailActionButton;
